import React,{Component} from 'react';

import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Button from '../../../shared/components/Button';
import Avatar from '../../../shared/components/Avatar';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';

import {
  alphabeticallySort,
  textContains
} from '../../../shared/utils';

class ManageUsers extends Component {
  componentDidMount(){
    this.props.loadUsersForAgency(this.props.activeAgencyId);
  }

  render(){
    const { users, match, updateUser } = this.props;

    return (
      <Container>
        <Row className='EntityList-title'>
          <Col xs='6'>
            <h1>Manage Team</h1>
          </Col>
          <Col xs='6'>
            <Button
              className='pull-right'
              linkHref={`${match.url}/new`}
            >
              Invite
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <SearchableDataTable
              items={users}
              hideSearch
              columns={[
                {
                  width:10,
                  renderCell:(item) => (
                    <div className={!item.active ? 'deactivated' : ''}>
                      <Avatar
                        userName={item.firstName}
                        imageUrl={item.avatarThumbnailURL}
                      />
                    </div>
                    )
                },
                {
                  display:'Name',
                  name:'name',
                  width:50,
                  sortFunc:(a,b) => alphabeticallySort(a.name,b.name),
                  filterFunc:(a,searchParam) => textContains(a.name,searchParam),
                  renderCell:(item) => (
                    <div className={!item.active ? 'deactivated' : ''}>
                      <Link to={`${match.url}/${item.id}`}>
                        {item.firstName || ''} {item.lastName || ''}
                      </Link>
                    </div>
                    )
                },
                {
                  display:'Role',
                  name:'role',
                  width:10,
                  sortFunc:(a,b) => b.isOwner - a.isOwner,
                  renderCell:(item) => (
                    <div className={!item.active ? 'deactivated' : ''}>
                      {item.isOwner ? 'Admin' : 'Creator'}
                    </div>
                    )
                },
                {
                  width:30,
                  renderCell:(item) => (
                    <div className='pull-right'>
                      <Button
                        size='sm'
                        linkHref={`${match.url}/${item.id}`}
                        textColor='#666666'
                        borderColor='#cccccc'
                        backgroundColor='#fff'
                      >
                        Edit
                      </Button>
                      &nbsp;&nbsp;
                      <DropdownButton
                        options={[
                          {
                            text:item.active ? 'Deactivate' : 'Activate',
                            onClick:() => updateUser(item.id,{active:!item.active})
                          }
                        ]}
                      />
                    </div>
                  )
                }
              ]}
            />
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default ManageUsers;



// WEBPACK FOOTER //
// ./src/routes/ManageUsers/components/ManageUsers.js